module.exports = __webpack_public_path__ + "img/IMG_1039_L_Foamcore.c98fa994.jpg";